import { createSelector } from 'reselect'
import { RootState } from 'store'

export const releaseSelector = createSelector(
  (state: RootState) => state.release,
  state => state
)

export const releaseInfoSelector = createSelector(releaseSelector, state => state.releaseInformation)
